/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  ProjectPermissionInfo,
  Status,
  SubscriptionDefaultValues,
  SupportedCurrency,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ProjectPermissionInfoFromJSON,
    ProjectPermissionInfoToJSON,
    StatusFromJSON,
    StatusToJSON,
    SubscriptionDefaultValuesFromJSON,
    SubscriptionDefaultValuesToJSON,
    SupportedCurrencyFromJSON,
    SupportedCurrencyToJSON,
} from '../models/index';

export interface EnqueueIntegrationRequest {
    integrationId: string;
}

export interface EnqueueProjectPrecalculationRequest {
    projectId: string;
}

/**
 * 
 */
export class SystemApi extends runtime.BaseAPI {

    /**
     * Returns openapi json.
     */
    async applicationOpenAPISpecificationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/openapi`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Returns openapi json.
     */
    async applicationOpenAPISpecification(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.applicationOpenAPISpecificationRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns quick info about the service.
     */
    async applicationStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Status>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatusFromJSON(jsonValue));
    }

    /**
     * Returns quick info about the service.
     */
    async applicationStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Status> {
        const response = await this.applicationStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Default values if no subscription present.
     */
    async defaultSubscriptionValuesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionDefaultValues>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/subscription-default-values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionDefaultValuesFromJSON(jsonValue));
    }

    /**
     * Default values if no subscription present.
     */
    async defaultSubscriptionValues(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionDefaultValues> {
        const response = await this.defaultSubscriptionValuesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Put integration on the top of the processing queue.
     */
    async enqueueIntegrationRaw(requestParameters: EnqueueIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Status>> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling enqueueIntegration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/queue/integration/{integrationId}`.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatusFromJSON(jsonValue));
    }

    /**
     * Put integration on the top of the processing queue.
     */
    async enqueueIntegration(requestParameters: EnqueueIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Status> {
        const response = await this.enqueueIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Put project on the top of the processing queue.
     */
    async enqueueProjectPrecalculationRaw(requestParameters: EnqueueProjectPrecalculationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Status>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling enqueueProjectPrecalculation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/queue/precalculation/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatusFromJSON(jsonValue));
    }

    /**
     * Put project on the top of the processing queue.
     */
    async enqueueProjectPrecalculation(requestParameters: EnqueueProjectPrecalculationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Status> {
        const response = await this.enqueueProjectPrecalculationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List of all available project permissions.
     */
    async projectPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectPermissionInfo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/project-permission`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectPermissionInfoFromJSON(jsonValue));
    }

    /**
     * List of all available project permissions.
     */
    async projectPermissions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectPermissionInfo> {
        const response = await this.projectPermissionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * List of supported currencies.
     */
    async supportedCurrenciesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SupportedCurrency>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/supported-currencies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportedCurrencyFromJSON));
    }

    /**
     * List of supported currencies.
     */
    async supportedCurrencies(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SupportedCurrency>> {
        const response = await this.supportedCurrenciesRaw(initOverrides);
        return await response.value();
    }

}
